import { Skeleton } from '@mui/material';

export const GeoDropdownSkeleton = () => (
  <Skeleton variant="rounded" sx={{ minHeight: '68px', width: { xs: '100%', sm: '213px' } }} />
);
